import type { DocumentExportDropdownMenuItemFragment } from "../client/generated";
import { useState } from "react";
import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { Icon } from "@mdi/react";
import { mdiExport } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { DocumentExportDialogContent } from "./DocumentExportDialogContent";
import { Dialog, DialogTrigger } from "@acdc2/ui/components/dialog";

type Props = {
  fragment: DocumentExportDropdownMenuItemFragment;
};

export function DocumentExportDropdownMenuItem({ fragment }: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
          <Icon path={mdiExport} size="1.25rem" />
          {t("DocumentExportDropdownMenuItem.label")}
        </DropdownMenuItem>
      </DialogTrigger>
      <DocumentExportDialogContent fragment={fragment} isOpen={isOpen} />
    </Dialog>
  );
}
